export const DECODE_ZIP = "DECODE_ZIP";
export const DECODE_ZIP_SUCCESS = "DECODE_ZIP_SUCCESS";
export const DECODE_ZIP_FAILED = "DECODE_ZIP_FAILED";
export const DECODE_VIN = "DECODE_VIN";
export const DECODE_VIN_SUCCESS = "DECODE_VIN_SUCCESS";
export const DECODE_VIN_FAILED = "DECODE_VIN_FAILED";
export const SUBMIT_FEES_FORM = "SUBMIT_FEES_FORM";
export const SUBMIT_FEES_SUCCESS = "SUBMIT_FEES_SUCCESS";
export const SUBMIT_FEES_FAILED = "SUBMIT_FEES_FAILED";
export const SAVE_FEES_FORM_DATA = "SAVE_FEES_FORM_DATA";
export const CLEAR_FEES_ERROR = "CLEAR_FEES_ERROR";
export const CLEAR_FEES_RESPONSE = "CLEAR_FEES_RESPONSE";
